/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
// Services
import { getRemoteWorkingPost } from './remoteWorkingPostService';

/**
 * @description useQuery Hook to get a post from its ID.
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {string} queryParams.postId
 * @param {Object} options useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<import('../types').RemoteWorkingPost, Error>}
 */
export const useRemoteWorkingPostQuery = (queryParams, options) => useQuery({
  queryKey: ['remoteWorkingPost', queryParams],
  queryFn: () => getRemoteWorkingPost(queryParams),
  ...options,
  meta: {
    preventToastError: true,
  },
});
